"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
require("core-js/modules/es6.regexp.replace");
const react_1 = __importDefault(require("react"));
const gatsby_1 = require("gatsby");
const styled_components_1 = __importDefault(require("styled-components"));
const router_1 = require("@reach/router");
const atoms_1 = require("@components/atoms");
const molecules_1 = require("@components/molecules");
const organisms_1 = require("@components/organisms");
const _utils_1 = require("@utils");
const _theme_1 = require("@theme");
const _store_1 = __importDefault(require("@store"));
var logo = require("../../assets/images/logos/prior.svg"); // Component
var SiteHeader = function SiteHeader(_ref) {
    var subHeaderContent = _ref.subHeaderContent, subHeaderMobileOnly = _ref.subHeaderMobileOnly;
    var compactHeader = _utils_1.useWaypoint({
        sensitivity: 1000,
        waypoint: 50
    });
    var _useHash = _utils_1.useHash(), hash = _useHash[0], setHash = _useHash[1];
    var _useGlobal = _store_1.default(function (state) {
        return state.user;
    }), user = _useGlobal[0];
    var _useGlobal2 = _store_1.default(function (state) {
        return state.visibleDropdown;
    }, function (actions) {
        return actions.setVisibleDropdown;
    }), visibleDropdown = _useGlobal2[0], setVisibleDropdown = _useGlobal2[1];
    var _useLocation = router_1.useLocation(), pathname = _useLocation.pathname;
    react_1.default.useEffect(function () {
        return setVisibleDropdown(undefined);
    }, [pathname]); // dismiss when page changes
    var _useWindowSize = _utils_1.useWindowSize(), width = _useWindowSize.width;
    var windowSize = width >= parseInt(_theme_1.breakpoint.desktop.replace(/px/, '')) ? 'desktop' : width >= parseInt(_theme_1.breakpoint.laptop.replace(/px/, '')) ? 'laptop' : width >= parseInt(_theme_1.breakpoint.tablet.replace(/px/, '')) ? 'tablet' : 'mobile';
    react_1.default.useEffect(function () {
        if (visibleDropdown) {
            document.getElementsByTagName('body')[0].classList.add('header-no-scroll');
        }
        else {
            if (hash === '#welcome') {
                setHash('');
            }
            document.getElementsByTagName('body')[0].classList.remove('header-no-scroll');
        }
        return function () {
            return document.getElementsByTagName('body')[0].classList.remove('no-scroll');
        };
    }, [visibleDropdown]);
    var toggleSearch = function toggleSearch() {
        /* Why is this focus() logic here instead of SearchInHeader?
         * iOS only allows us to set focus directly based on a click.
         * An observer in SearchInHeader like React.useEffect(() => {}, [visibleDropdown]) is indirect.
         */
        var searchField = document.getElementById('keywords');
        if (visibleDropdown !== 'search') {
            setVisibleDropdown('search');
            searchField === null || searchField === void 0 ? void 0 : searchField.setAttribute('autofocus', 'autofocus');
            searchField === null || searchField === void 0 ? void 0 : searchField.focus();
        }
        else {
            setVisibleDropdown(undefined);
            searchField === null || searchField === void 0 ? void 0 : searchField.removeAttribute('autofocus');
        }
    };
    var toggleAccount = function toggleAccount() {
        return setVisibleDropdown(visibleDropdown === 'account' ? undefined : 'account');
    };
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, {
        compactHeader: compactHeader,
        windowSize: windowSize
    }, /*#__PURE__*/ react_1.default.createElement(Header, null, /*#__PURE__*/ react_1.default.createElement(Content, {
        compactHeader: compactHeader,
        windowSize: windowSize
    }, /*#__PURE__*/ react_1.default.createElement(Left, null, !user && /*#__PURE__*/ react_1.default.createElement(StyledButton, {
        onClick: toggleAccount,
        type: "gold"
    }, "Join"), /*#__PURE__*/ react_1.default.createElement(molecules_1.Menu, {
        active: visibleDropdown === 'sitemap'
    })), /*#__PURE__*/ react_1.default.createElement(Center, null, /*#__PURE__*/ react_1.default.createElement(LogoWrapper, null, /*#__PURE__*/ react_1.default.createElement(Logo, Object.assign({
        to: "/"
    }, {
        compactHeader: compactHeader
    }), "Prior"))), /*#__PURE__*/ react_1.default.createElement(Tools, null, /*#__PURE__*/ react_1.default.createElement(molecules_1.SiteHeaderTool, {
        onClick: toggleSearch,
        active: visibleDropdown === 'search'
    }, "Search"), /*#__PURE__*/ react_1.default.createElement(molecules_1.SiteHeaderTool, {
        onClick: toggleAccount,
        active: visibleDropdown === 'account'
    }, "Account")))), /*#__PURE__*/ react_1.default.createElement(HeaderDropdown, Object.assign({
        hide: visibleDropdown !== 'sitemap'
    }, {
        compactHeader: compactHeader
    }), /*#__PURE__*/ react_1.default.createElement(organisms_1.SiteMap, {
        theme: "light"
    })), /*#__PURE__*/ react_1.default.createElement(HeaderDropdown, Object.assign({
        hide: visibleDropdown !== 'search'
    }, {
        compactHeader: compactHeader
    }), /*#__PURE__*/ react_1.default.createElement(organisms_1.SearchInHeader, null)), /*#__PURE__*/ react_1.default.createElement(HeaderDropdown, Object.assign({
        hide: visibleDropdown !== 'account'
    }, {
        compactHeader: compactHeader
    }), /*#__PURE__*/ react_1.default.createElement(organisms_1.AccountInHeader, null)), subHeaderContent && /*#__PURE__*/ react_1.default.createElement(SubHeader, {
        compactHeader: compactHeader,
        windowSize: windowSize,
        subHeaderMobileOnly: subHeaderMobileOnly
    }, subHeaderContent), /*#__PURE__*/ react_1.default.createElement(atoms_1.Onionskin, Object.assign({
        hide: visibleDropdown === undefined
    }, {
        compactHeader: compactHeader,
        windowSize: windowSize
    }, {
        onClick: function onClick() {
            return setVisibleDropdown(undefined);
        }
    })), /*#__PURE__*/ react_1.default.createElement(BoxShadow, null));
}; // Styling
var headerTransition = '0.35s ease-in-out 0.1s';
var Wrapper = styled_components_1.default.header.attrs(function (_ref2) {
    var compactHeader = _ref2.compactHeader, windowSize = _ref2.windowSize;
    return {
        style: {
            transform: "translate3d(\n      0, " + (!compactHeader ? 0 : !(windowSize === 'desktop') ? -16 : -24) + "px, 0\n    )"
        }
    };
}).withConfig({
    displayName: "SiteHeader__Wrapper",
    componentId: "sc-13cjzb6-0"
})(["position:fixed;z-index:1000;top:0px;left:0px;width:100%;height:fit-content;box-shadow:0px 1px 0px ", ";transition:transform ", ";backface-visibility:hidden;will-change:transform;"], _utils_1.rgba(_theme_1.palette.snow, 0.04), headerTransition);
var BoxShadow = styled_components_1.default.div.withConfig({
    displayName: "SiteHeader__BoxShadow",
    componentId: "sc-13cjzb6-1"
})(["position:absolute;z-index:-1;bottom:6%;left:1%;width:98%;height:94%;box-shadow:0 24px 32px ", ";pointer-events:none;backface-visibility:hidden;"], _utils_1.rgba(_theme_1.palette.black, 0.16));
/* Note: For padding that pushes the site layout below the fixed header and
*       subheader, see /src/components/layouts/Layout.tsx
*/
var Header = styled_components_1.default.header.withConfig({
    displayName: "SiteHeader__Header",
    componentId: "sc-13cjzb6-2"
})(["position:relative;z-index:100;background-color:", ";width:100%;height:", "px;overflow:hidden;backface-visibility:hidden;", "{height:", "px;}", "{height:", "px;}"], _theme_1.palette.ink, _theme_1.headerHeight['mobile'], _utils_1.mediaQuery('tablet'), _theme_1.headerHeight['laptop'], _utils_1.mediaQuery('desktop'), _theme_1.headerHeight['desktop']);
var Content = styled_components_1.default.div.attrs(function (_ref3) {
    var compactHeader = _ref3.compactHeader, windowSize = _ref3.windowSize;
    return {
        style: {
            transform: "translate3d(\n      0, " + (!compactHeader ? 0 : !(windowSize === 'desktop') ? 8 : 12) + "px, 0\n    )"
        }
    };
}).withConfig({
    displayName: "SiteHeader__Content",
    componentId: "sc-13cjzb6-3"
})(["position:relative;width:100%;height:100%;transition:transform ", ";will-change:transform;backface-visibility:hidden;"], headerTransition); // Left
var Left = styled_components_1.default.div.withConfig({
    displayName: "SiteHeader__Left",
    componentId: "sc-13cjzb6-4"
})(["position:absolute;top:0;left:0;display:flex;flex-direction:row;justify-content:space-between;align-items:center;width:auto;height:100%;"]);
var StyledButton = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, props);
}).withConfig({
    displayName: "SiteHeader__StyledButton",
    componentId: "sc-13cjzb6-5"
})(["display:none;", "{display:block;width:auto;height:100%;border:none;transform:none !important;& > a{padding:0 40px;}}"], _utils_1.mediaQuery('tablet')); // Center
var Center = styled_components_1.default.div.withConfig({
    displayName: "SiteHeader__Center",
    componentId: "sc-13cjzb6-6"
})(["position:absolute;left:50%;width:104px;height:100%;transform:translateX(-50%);", "{width:144px;padding:0 20px;}", "{width:186px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('desktop')); // Logo
var LogoWrapper = styled_components_1.default.div.withConfig({
    displayName: "SiteHeader__LogoWrapper",
    componentId: "sc-13cjzb6-7"
})(["position:relative;width:100%;height:100%;opacity:1;transform:scale3d(1,1,1);transition:transform 0.6s 0.2s ease-in-out,opacity 0.6s 0.2s ease-in-out;will-change:transform,opacity;backface-visibility:hidden;"]);
var Logo = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: props.to,
        className: props.className
    }, props.children);
}).withConfig({
    displayName: "SiteHeader__Logo",
    componentId: "sc-13cjzb6-8"
})(["display:block;background-color:", ";mask-image:url(", ");mask-repeat:no-repeat;mask-position:center;mask-size:contain;width:100%;height:100%;transition:transform ", ";will-change:transform;transform:scale3d( ", ",", ",1 );backface-visibility:hidden;", "{width:100%;height:100%;}text-indent:-9999px;overflow:hidden;"], _theme_1.palette.snow, logo, headerTransition, function (props) {
    return !props.compactHeader ? 1 : 0.8;
}, function (props) {
    return !props.compactHeader ? 1 : 0.8;
}, _utils_1.mediaQuery('tablet')); // Tools
var Tools = styled_components_1.default.ul.withConfig({
    displayName: "SiteHeader__Tools",
    componentId: "sc-13cjzb6-9"
})(["position:absolute;right:0;display:flex;flex-direction:row;justify-content:flex-end;align-items:center;height:100%;padding:0 12px;", "{padding:0 20px;}"], _utils_1.mediaQuery('tablet')); // Subheader
/* Note: For padding that pushes the site layout below the fixed header and
*       subheader, see /src/components/layouts/Layout.tsx
*  Note: "subHeaderMobileOnly" only displays white strip under header in Mobile.
*       (This navigation is a sidebar on laptop+)
*/
var SubHeader = styled_components_1.default.div.attrs(function (_ref4) {
    var compactHeader = _ref4.compactHeader, windowSize = _ref4.windowSize;
    return {
        style: {
            height: (!compactHeader && windowSize === 'desktop' ? 72 : compactHeader && windowSize === 'desktop' ? 56 : !compactHeader && windowSize === 'laptop' ? 64 : compactHeader && windowSize === 'laptop' ? 48 : !compactHeader ? 48 : 40) + "px"
        }
    };
}).withConfig({
    displayName: "SiteHeader__SubHeader",
    componentId: "sc-13cjzb6-10"
})(["display:block;", "{display:", ";}position:relative;background-color:", ";width:100%;transition:height ", ";will-change:height;backface-visibility:hidden;&::after,&::before{z-index:2;position:absolute;top:0;right:0;background:linear-gradient( 90deg,", " 0%,", " 100% );height:calc(100% - 2px);width:24px;pointer-events:none;content:'';", "{width:40px;}}&::before{left:0;transform:rotate(180deg);}"], _utils_1.mediaQuery('laptop'), function (props) {
    return props.subHeaderMobileOnly ? 'none' : 'block';
}, _theme_1.palette.snow, headerTransition, _utils_1.rgba(_theme_1.palette.snow, 0), _utils_1.rgba(_theme_1.palette.snow, 1), _utils_1.mediaQuery('tablet')); // Sitemap
/* Note: when in "dev" (local) mode, the first initiation of a HeaderDropdown will "pop" into place.
 * Subsequent clicks will correctly transition in and out.
 * We did not have this issue when we had visibility: (hide) ? 'hidden' : 'visible' as a style,
 *   but that prevents iOS from being able to focus an input upon click.
 * This problem does not exist in deployment, so don't go crazy trying to fix this for dev.
 */
var HeaderDropdown = styled_components_1.default.div.attrs(function (_ref5) {
    var hide = _ref5.hide;
    return {
        style: {
            transform: hide ? 'translateY(30px)' : 'translateY(0px)',
            opacity: hide ? 0 : 1,
            pointerEvents: hide ? 'none' : 'all'
        }
    };
}).withConfig({
    displayName: "SiteHeader__HeaderDropdown",
    componentId: "sc-13cjzb6-11"
})(["z-index:90;position:absolute;width:100%;height:fit-content;max-height:calc(100vh - ", "px);overflow-y:auto;overflow-x:hidden;-webkit-overflow-scrolling:touch;&::-webkit-scrollbar{width:0px;height:0px;}transition:transform 0.6s cubic-bezier(0.215,0.61,0.355,1),opacity 0.4s ease-in-out;will-change:transform,opacity;backface-visibility:hidden;", "{max-height:calc(100vh - ", "px);}", "{max-height:calc(100vh - ", "px);}"], function (props) {
    return !props.compactHeader ? 160 : 144;
}, _utils_1.mediaQuery('tablet'), function (props) {
    return !props.compactHeader ? 80 : 64;
}, _utils_1.mediaQuery('desktop'), function (props) {
    return !props.compactHeader ? 96 : 72;
}); // Typing
exports.default = SiteHeader;
